import request, { ResponseData } from "logic/src/utils/request";
import { IRichModalFileCommitInfo } from "logic/src/objects/file/types";
import { PATH_PREFIX, ResCode } from "../constants/request";

const PREFIX = `${PATH_PREFIX}/video-edit/v1.0.0`;

// 视频编辑白名单检查API
export async function checkVideoEditWhitelist(): Promise<ResponseData> {
  return request.get(`${PREFIX}/whitelist`, {});
}

// 生成TITLE
export async function generateTitle(content: string): Promise<ResponseData> {
  const params = {
    "channel": "chat-web",
    "client_chan": "titleOnCom",
    "content": content,
  };
  return request.post(`${PREFIX}/generate-title`, params, {
    timeout: 3 * 60 * 1000,
  });
}

// 视频编辑申请试用API
export async function applyVideoEdit(data: {
  email: string;
  reason: string;
}): Promise<ResponseData> {
  return request.put(`${PREFIX}/apply`, data);
}

export async function commitFile(params: {
  file_id?: string;
  file_ids?: string[];
  urls?: string[];
  url?: string;
}): Promise<{
  code: number; // 为16000时，表示用户无视频编辑权限,
  message: IRichModalFileCommitInfo[];
}> {
  return request.post(`${PREFIX}/commit`, params).then(res => {
    return res;
    // if (res.code === ResCode.Success) {
    //   return res.message;
    // } else {
    //   return res;
    // }
  });
}

// 缓存key, value键值对,供以后调用
export async function cacheFile(
  data: Array<{
    "key": string;
    "file_id": string;
  }>,
): Promise<ResponseData> {
  return request.post(`${PREFIX}/cache-commit`, { files: data }).then(res => {
    if (res.code === ResCode.Success) {
      return res.message;
    } else {
      return res;
    }
  });
}
